import { SUPER_ADMIN } from '@/lib/constants/securityRoles'
const userHasRoles = ({ user, allowedRoles = [], hiddenRoles = [] }) => {
  return user &&
          user.securityRoles &&
          (user.securityRoles.includes(SUPER_ADMIN.name) ||
          allowedRoles.some(role => user.securityRoles.includes(role.name) && !hiddenRoles.some(hr => hr.name === role.name)))
}

export default userHasRoles
